export const countries = {
  SE: 'swe',
  DK: 'dnk',
  NO: 'nor',
  FI: 'fin',
  NL: 'nld',
  AT: 'aut',
  US: 'usa',
  GB: 'gbr',
  DE: 'deu',
  CH: 'che'
}

export const currencies = {
  AUD: { TOKENIZE: 'AUD', KP: 'AUD', KCO: 'AUD' },
  CAD: { TOKENIZE: 'C$', KP: 'C$', KCO: 'C$' },
  CHF: { TOKENIZE: 'CHF', KP: 'CHF', KCO: 'CHF' },
  DKK: { TOKENIZE: 'kr', KP: 'kr', KCO: 'DKK' },
  EUR: { TOKENIZE: '€', KP: '€', KCO: '€' },
  GBP: { TOKENIZE: '£', KP: '£', KCO: '£' },
  JPY: { TOKENIZE: 'JPY', KP: 'JPY', KCO: 'JPY' },
  NOK: { TOKENIZE: 'kr', KP: 'kr', KCO: 'NOK' },
  NZD: { TOKENIZE: 'NZD', KP: 'NZD', KCO: 'NZD' },
  SEK: { TOKENIZE: 'kr', KP: 'kr', KCO: 'SEK' },
  USD: { TOKENIZE: '$', KP: '$', KCO: '$' },
  PLN: { TOKENIZE: 'zł', KP: 'zł', KCO: 'PLN' }
}
